import {getDaysInYear} from 'date-fns';

import {dotToComma, stringToNumber} from '@wallex-core-client/utils';

export const calcReward = (value: string | number, yearPercentage: string | number): string => {
  const reward = (stringToNumber(value) * (+yearPercentage / 100)) / getDaysInYear(new Date());
  return dotToComma(reward);
};
